class Event {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //------- 画像のheught,widthをrem化 ---------
    $('.text-editor img').each(function(index, el) {
      let width = $(el).attr('width')
      // $(el).attr('width')
      $(el).css({'width': `${width * 0.1 + 'rem'}`, 'height': `auto`})
    })
    //------- 画像のheught,widthをrem化 〆 ---------
  }
}
class PeopleSingle {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let peopleTl = gsap.timeline();

    peopleTl.to('.js-img', 0.75, {
      clipPath: "inset(0% 0% 0% 0%)",
      delay: 0.3,
      onComplete: function(self) {
        $('.js-ttl').addClass('is-inview');
      }
    })

    peopleTl.to('.js-scroll, .js-subttl, .js-drawer, .js-header', 0.25, {
      opacity: 1,
      delay: 1,
      onStart: function() {
        $('.js-lineTxt').addClass('is-inview');
      }
    })
  }
}

let mvTl = gsap.timeline();
let bgSlide;
let humanSlide;

class Top {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-humanSlide, .js-mvNone, .js-drawer, .js-mv').css({'opacity': '0'});

    // **************************************
    // MVアニメーション
    // **************************************

    let jsMvNewsInterval;

    let args = {
      loop:true,
      autoplay: { // 自動再生
        delay: 2500, // 1.5秒後に次のスライド
        disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
      },
      speed: 750,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
    }

    bgSlide = new Swiper('.js-bgSlide', {
      ...args
    });

    humanSlide = new Swiper('.js-humanSlide', {
      ...args
    });

    $('.mv-wrap path').addClass('is-anime');
    
    humanSlide.autoplay.stop();
    bgSlide.autoplay.stop();

    mvTl.to('.js-humanSlide', 1, {
      opacity: 1,
      delay: 3,
      onStart: () => {
        $('.js-h1 > div').addClass('is-active');
      },
      onComplete: () => {
        humanSlide.autoplay.start();
        bgSlide.autoplay.start();
      }
    })

    mvTl.to('.js-mv, .js-mvNone, .js-drawer', 0.75, {
      opacity: 1,
      onStart: () => {
        clearInterval(jsMvNewsInterval);

        jsMvNewsInterval = setInterval(() => {
          jsMvNews();
        }, 3000);
      },
    }, '-=0.5')

    
    // **************************************
    // MVニュース
    // **************************************

    $('.js-mvNews-arrow').click(function() {
      jsMvNews();
      clearInterval(jsMvNewsInterval);

      jsMvNewsInterval = setInterval(() => {
        jsMvNews();
      }, 3000);
    })

    function jsMvNews() {
      let nowActive = $('.js-news .is-active');
      nowActive.removeClass('is-active');
      nowActive.css({'transform': 'translateY(4rem)','opacity': '0'});

      setTimeout(() => {
        nowActive.css({'transform': 'translateY(-4rem)'});
      }, 300);

      $('.js-mvNews-arrow').css({'pointerEvents': 'none'});

      let nextActive;
      
      if($(this).hasClass('js-mvNews-next')) {
        nextActive = nowActive.next().length ? nowActive.next() : $('.js-news > div:first-of-type');
      } else {
        nextActive = nowActive.prev().length ? nowActive.prev() : $('.js-news > div:last-of-type');
      }
      nextActive.addClass('is-active');

      setTimeout(() => {
        $('.js-mvNews-arrow').css({'pointerEvents': 'auto'});
      }, 300);
    }
    
    // **************************************
    // MV背景
    // **************************************

    let trigger = ScrollTrigger.create({
      trigger: ".js-middle-trigger",
      start: "top top",
      end: "top top",
      onEnter: () => {
        $('.js-bgSlide, .js-humanSlideWrap').css({'opacity': '0'});
      },
      onEnterBack: () => {
        $('.js-bgSlide, .js-humanSlideWrap').css({'opacity': '1'});
      }
    })
    
    // **************************************
    // ATJを知る
    // **************************************

    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }

    let atjSwiperFlag = true;

    let atjSwiper01 = "";

    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          if(atjSwiperFlag === true) {
            atjSwiper01 = new Swiper('.atjSwiper01', {
              loop:true,
              autoplay: { // 自動再生
                delay: 4000, // 1.5秒後に次のスライド
                disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
              },
              speed: 700,
              effect: 'fade',
              fadeEffect: {
                crossFade: true
              },
              slideChangeTransitionStart: function () {
                this.autoplay.stop();
                this.autoplay.start();
              },
              touchEnd: function () {
                this.autoplay.stop();
                this.autoplay.start();
              },
            });
            const atjSwiper02 = new Swiper('.atjSwiper02', {
              loop:true,
              spaceBetween: 10,
              speed: 500,
              breakpoints: {
                768: {
                  spaceBetween: 4,
                },
              },
              pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
                renderFraction: function (currentClass, totalClass) {
                  return (
                    '<span class="' + currentClass + '"></span>' +
                    '<span class="border js-border"><span></span></span>' +
                    '<span class="' + totalClass + '"></span>'
                  );
                },
                formatFractionCurrent: function (number) {
                  let num = number % 3 === 0 ? '3' : String(number % 3); // 文字列に統一
                  return '0' + num; // 01, 02, 03 のように2桁表記
                },
                formatFractionTotal: function () {
                  return '03';
                }
              },
              on: {
                init: function () {
                  
                  setTimeout(() => {
                    const pagiNation = document.querySelector('.swiper-pagination');
                    pagiNation.classList.add('is-active');
                  }, 100);
                },
                slideChangeTransitionStart: function () {
                  const border = document.querySelector('.js-border span');
                  if (border) {
                    border.style.transitionTimingFunction = 'ease';
                    border.style.transitionDuration = '500ms';
                    border.style.transform = 'scaleX(0)';
                  }
                  atjSwiper01.autoplay.stop();
                  atjSwiper01.autoplay.start();
                },
                slideChangeTransitionEnd: function () {
                  const border = document.querySelector('.js-border span');
                  if (border) {
                    border.style.transitionTimingFunction = 'linear';
                    border.style.transitionDuration = '4000ms';
                    border.style.transform = 'scaleX(1)';
                  }
                },
                touchEnd: function () {
                  atjSwiper01.autoplay.stop();
                  atjSwiper01.autoplay.start();
                },
              }
            });
            atjSwiper01.controller.control = [atjSwiper02];
            atjSwiper02.controller.control = [atjSwiper01];

            atjSwiperFlag = false;
          }
        }
      });
    }, options);

    let swiperEl = document.querySelectorAll('.atjSwiper01');

    // .atjSwiper02 にホバーしたら atjSwiper01 の autoplay を停止
    $(".atjSwiper01, .atjSwiper02").hover(
      function () {
        atjSwiper01.autoplay.stop();
      },
      function () {
        atjSwiper01.slideNext();
        atjSwiper01.autoplay.start();
      }
    );

    swiperEl.forEach((e)=>{
      observerEnter.observe(e);
    });

    // **************************************
    // タブレット用 アスペクト比をチェックし、htmlタグにクラスを追加/削除する関数
    // **************************************
    function updateHtmlClass() {
      var aspectRatio = $(window).width() / $(window).height(); // ウィンドウの幅 ÷ 高さ でアスペクト比を取得
  
      if (aspectRatio <= 1.7) {
        $("html").addClass("tablet"); // 1.7以下なら .tablet クラスを追加
      } else {
        $("html").removeClass("tablet"); // 1.7を超えたら .tablet クラスを削除
      }
    }
  
    // ページ読み込み時に実行
    updateHtmlClass();
  
    // ウィンドウサイズ変更時に再チェック
    $(window).on("resize", updateHtmlClass);


    $(".js-view-opacity, .js-view-opacity-top").each(function() {
      const $element = $(this);

      // 元の内容を取得
      const originalContent = $element.html();

      // 新しい内容を <span> で囲んで生成
      const spanContent = `<div class="duplicate" style="width: 100%;">${originalContent}</div><div class="duplicate" style="width: 100%;">${originalContent}</div>`;

      // .js-view-opacity の要素に新しい内容を設定
      $element.html(spanContent);
    })

    gsap.to('.js-view', 
      {
        scrollTrigger: {
          trigger: '.js-view',
          start: 'top+=150px bottom',
          onEnter: (self) => {
            self.trigger.classList.add('is-active');
            gsap.to(self.trigger.querySelectorAll('.duplicate'), 1.5, {
              clipPath: "inset(0% 0% 0% 0%)",
              duration: 1.6,
              stagger: 0.2,
              ease:"cubic.inOut",
              onComplete: function(self) {
                $(this.targets()).css({'clipPath': 'none'});
              }
            });
          },
        }
      })
  }
}

let lenis;

class Common {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){

    // 幅が768px以上のビューポートをターゲットとするメディアクエリを作成
    const sp = window.matchMedia('(max-width: 767px)')

    if (!sp.matches) {
      lenis = new Lenis({
        duration: 0.4, // スクロールアニメーションの時間
      });

      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      
      requestAnimationFrame(raf);
    }

    $('.js-drawer').click(function() {
      $('html').toggleClass('is-drawer');

      if($('html').hasClass('is-drawer')) {
        setTimeout(() => {
          let stop = !sp.matches ? lenis.stop() : scrollBan();
        }, 700);
      } else {
        let stop = !sp.matches ? lenis.start() : scrollBan();
      }
    })
    // メディアクエリがtrueかどうかをチェック
    if (sp.matches) {
      $('.js-accordion-inner').hide();
    }

    $('.js-accordionTrigger').click(function() {
      $(this).toggleClass('is-active');
      $(this).parent().next().slideToggle();
    })

    // **************************************
    // ローディング
    // **************************************

    setTimeout(() => {
      $('.js-loading').addClass('is-active');
      mvTl.play()
    }, 1000);

    // **************************************
    // ローディング
    // **************************************

    if($('.js-mv-primary').length) {
      $('.js-loadingBottom').addClass('is-view');
      $('.js-loadingBottom-display').animate({'opacity': '0'}, 0);
      setTimeout(() => {
        $('.js-loadingBottom').addClass('is-active');
        $('.js-fvImg').animate({'opacity': '1'}, 0);
        setTimeout(() => {
          $('.js-loadingBottom-ttl').addClass('is-inview');
          setTimeout(() => {
            $('.js-loadingBottom-lineTxt').addClass('is-inview');
            $('.js-loadingBottom-display').animate({'opacity': '1'}, 500);
            $('.js-loadingBottom-display').addClass('is-view');
          }, 500);
        }, 500);
      }, 500);
    }
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class HumanSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }

    let humanFlag = true;

    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          if(humanFlag === true) {
            var humanSwiper = new Swiper("." + this.el, {
              slidesPerView: 1.2,
              speed: 500,
              navigation: {
                nextEl: ".humanSwiper-button-next",
                prevEl: ".humanSwiper-button-prev",
              },
              breakpoints: {
                // スライドの表示枚数：500px以上の場合
                767: {
                  slidesPerView: 3,
                }
              },
              pagination: {
                el: '.humanSwiper-pagination',
                type: 'fraction',
                renderFraction: function (currentClass, totalClass) {
                  return (
                    '<span class="border js-humanSwiper-border"><span></span></span>'
                  );
                },
                formatFractionCurrent: function (number) {
                  let num = number % 3 === 0 ? '3' : String(number % 3); // 文字列に統一
                  return '0' + num; // 01, 02, 03 のように2桁表記
                },
              },
              on: {
                init: function () {
                  setTimeout(() => {
                    const pagiNation = document.querySelector('.humanSwiper-pagination');
                    pagiNation.classList.add('is-active');
                  }, 100);
                },
                slideChangeTransitionStart: function () {
                  const border = document.querySelector('.js-humanSwiper-border span');
                  if (border) {
                    border.style.transitionTimingFunction = 'ease';
                    border.style.transitionDuration = '500ms';
                    border.style.transform = 'scaleX(0)';
                  }
                },
                slideChangeTransitionEnd: function () {
                  const border = document.querySelector('.js-humanSwiper-border span');
                  if (border) {
                    border.style.transitionTimingFunction = 'linear';
                    border.style.transitionDuration = '3500ms';
                    border.style.transform = 'scaleX(1)';
                  }
                },
              }
            });
            
            // スマホ以外なら autoplay スタート
            if (window.innerWidth >= 768) {
              humanSwiper.params.autoplay = { delay: 4000, disableOnInteraction: false };
              humanSwiper.autoplay.start();
            }
            humanFlag = false;
          }
        }
      });
    }, options);

    let swiperEl = document.querySelectorAll("." + this.el);

    swiperEl.forEach((e)=>{
      observerEnter.observe(e);
    });
  }
}
// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InterviewSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }

  event(){
    const mySwiper = new Swiper('.swiper', {

      loop: false,
      slidesPerView: 3,

      // breakpoints: {
      //   789: {
      //     loop: false,
      //     slidesPerView: 3,
      //   },
      // },
    });
  }
}
class InviewEvent {
  constructor(el, opt){
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);

    let fvTime = $('.js-mv-primary').length ? '1000' : '0';

    setTimeout(() => {
      this.inviewEachUp('.js-inview-each-fv');
    }, fvTime);

    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class LenisExclude {
  constructor(el,opt){
    this.el = el;
    if(document.querySelector(el)){
      this.event(el);
    }
  }
  event(el){
    const excludeEle = document.querySelector(el);
    excludeEle.addEventListener('wheel',(e)=>{
      e.stopPropagation();
    })
  }
}

class Mobile {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {

    $(".item").css({
      "opacity": "0",
      "pointer-events": "none",
      "right": "-100%"
    });
    
    const _this = this;

    $(".open-modal").on("click", function (e) {
      e.stopPropagation(); // クリックイベントのバブリングを防ぐ
      $('html').addClass('is-modal');
      var targetId = $(this).attr("id").replace("open", "mobile");
      var $targetModal = $("#" + targetId);

      // すべてのモーダルを閉じる
      $(".item").css({
        "opacity": "0",
        "pointer-events": "none",
        "right": "-100%"
      });

      // クリックした要素に対応するモーダルを開く
      $targetModal.css({
        "opacity": "1",
        "pointer-events": "auto",
        "right": "0%"
      });

      // .close の right を 2rem に設定
      $targetModal.find(".close").css("right", "2rem");

      // スクロール禁止＆画面固定
      toggleScrollBan(true);
    });

    $(".close").on("click", function (e) {
      e.stopPropagation(); // バブリング防止
      const $modal = $(".item");
      closeModal($modal);
    });

    // モーダル内でホイールスクロールを制御
    $(".item").on("wheel", function (event) {
      const $this = $(this);
      const scrollTop = $this.scrollTop();
      const scrollHeight = $this.prop("scrollHeight");
      const height = $this.outerHeight();
      const delta = event.originalEvent.deltaY;

      if (
        (delta < 0 && scrollTop > 0) ||
        (delta > 0 && scrollTop + height < scrollHeight)
      ) {
        event.stopPropagation();
      } else {
        $this.scrollTop(scrollTop + delta * 0.3);
        event.preventDefault();
      }
    });
  }
}

// モーダルを閉じる関数
function closeModal($modal) {
  $modal.css({
    "opacity": "0",
    "pointer-events": "none",
    "right": "-100%"
  });

  // .close の right を -100% に変更
  $modal.find(".close").css("right", "-100%");

  if($('html').hasClass('is-modal')) {
    // スクロール再開
    toggleScrollBan(false);
  }

  $('html').removeClass('is-modal');
}

// -------------------------------------------------
// スクロール禁止・再開（位置を保持）
// -------------------------------------------------
window.scrollTopPos = 0;

function toggleScrollBan(isBan) {
  const body = document.querySelector('html');
  if (isBan) {
    if ($(window).scrollTop() != 0) {
      window.scrollTopPos = $(window).scrollTop();
    }
    
    // スクロール位置を記録
    body.style.position = 'fixed';
    body.style.top = `-${window.scrollTopPos}px`;
    body.style.width = '100%';
    body.classList.add('is-hidden');

    $("html").css({ 'top': '-' + window.scrollTopPos + 'px' }).addClass('is-active');
  } else {
    // `position: fixed` を解除
    body.style.position = '';
    body.style.top = '';
    body.style.width = '';
    body.classList.remove('is-hidden');
    
    $("html").removeClass('is-active');
    
    // 保存したスクロール位置に戻す
    $(window).scrollTop(window.scrollTopPos);
  }
}

// クラスを適用してモーダルを制御
$(document).ready(function () {
  new Mobile("js-mobile");
});

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}
class SmothScroll {
  constructor(el,opt){
    $('a[href^="#"]').click(function () {
      var speed = 500;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $("html, body").animate({
        scrollTop: position
      }, speed, "swing");
      return false;
    });
  }
};

(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let smothScroll = new SmothScroll();
  let mobile = new Mobile('js-mobile');
  let interviewSwiper = new InterviewSwiper('interviewSwiper');
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let formConvert = new FormConvert('js-convert');
  let humanSwiper = new HumanSwiper('js-humanSwiper');
  let common = new Common();
  new LenisExclude('.js-lenis-exclude');

  let top = new Top('p-top');
  let event = new Event('p-event');
  let peopleSingle = new PeopleSingle('p-people-single');
});